import React from 'react';
import './Spinner.css';

export default (props) => {
    return (
        <div className={`${"Spinner"}${props.className ? " " + props.className : ""}`}>
            <i className="fas fa-spinner fa-pulse"></i>
        </div>
    );
}
